import { useState } from 'react';
import { useInView } from '../../hooks/useInView';
import { Plus } from 'lucide-react';

const faqs = [
  { q: 'Como funciona o pagamento?', a: 'O pagamento é feito via Mercado Pago, plataforma segura e reconhecida no Brasil. Aceitamos cartões de crédito, débito e PIX.' },
  { q: 'Posso cancelar a qualquer momento?', a: 'Sim! Você pode cancelar sua assinatura a qualquer momento. Seu acesso continua até o final do período pago.' },
  { q: 'Meus dados financeiros estão seguros?', a: 'Absolutamente! Seus dados são criptografados e armazenados com segurança. Nunca compartilhamos informações com terceiros.' },
  { q: 'Como funciona o bot do WhatsApp?', a: 'Nosso bot com IA já está ativo! Basta vincular seu número nas configurações e começar a conversar. Você pode registrar gastos por texto, áudio ou foto de recibo, consultar saldo e extrato, criar metas e investimentos, e receber resumos diários — tudo direto no WhatsApp.' },
  { q: 'Preciso instalar algum aplicativo?', a: 'Não! A Aretê funciona 100% no navegador, sem downloads. Acesse de qualquer dispositivo — celular, tablet ou computador. E o bot WhatsApp funciona no app que você já usa todos os dias.' },
];

function FaqItem({ faq, index, isInView }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      data-testid={`faq-${index}`}
      className={`rounded-2xl border border-border/60 bg-card/50 backdrop-blur-sm overflow-hidden transition-all duration-700 hover:border-primary/25 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
      style={{ transitionDelay: `${index * 70}ms` }}
    >
      <button
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left group"
        data-testid={`faq-toggle-${index}`}
      >
        <span className="font-semibold text-foreground group-hover:text-primary transition-colors">{faq.q}</span>
        <span className={`shrink-0 flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary transition-transform duration-300 ${open ? 'rotate-45' : ''}`}>
          <Plus className="w-4 h-4" />
        </span>
      </button>
      <div className={`grid transition-all duration-300 ease-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
        <div className="overflow-hidden">
          <p className="px-6 pb-6 text-sm text-muted-foreground leading-relaxed">{faq.a}</p>
        </div>
      </div>
    </div>
  );
}

export default function FaqSection() {
  const [ref, isInView] = useInView({ threshold: 0.1 });
  return (
    <section className="relative py-32 overflow-hidden" data-testid="faq-section">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-muted/10 to-background" />
      <div className="relative mx-auto max-w-3xl px-6" ref={ref}>
        <div className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h2 className="text-4xl sm:text-5xl font-bold tracking-tight text-foreground">Perguntas Frequentes</h2>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, i) => <FaqItem key={faq.q} faq={faq} index={i} isInView={isInView} />)}
        </div>
      </div>
    </section>
  );
}
